import PropTypes from "prop-types";
import { StyledTagContainer } from "../../styles/StyledTag";

export default function TagContainer({ children }) {
	return <StyledTagContainer>{children}</StyledTagContainer>;
}

TagContainer.propTypes = {
	children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
};
